import { variant3 } from './constants';
import { ONTARIO_PROVINCE_CODE, ONTARIO_USER_LOCATION_PARAMS } from '../../utils/constants';

export const getDefaultLocationParamsForProvince = defaultProvince => {
  if (!defaultProvince) return { province: { abbreviation: defaultProvince } };
  switch (defaultProvince?.toLocaleUpperCase()) {
    case ONTARIO_PROVINCE_CODE:
      return ONTARIO_USER_LOCATION_PARAMS;
    default:
      return { province: { abbreviation: defaultProvince } };
  }
};

export const useConfiguration = variant => {
  let submitButtonStyling = 'primary';

  switch (variant) {
    // PE
    case variant3:
      submitButtonStyling = 'special';
      break;
    default:
      break;
  }

  return { submitButtonStyling };
};
